import { SortProductsItem } from '../../../services/MVP/models';

// Action Types
export enum Types {
  CLEAN_CROSS_SELL_STATE = 'cross-sell/CLEAN_CROSS_SELL_STATE',
  LOAD_CROSS_SELL_ITEMS = 'cross-sell/LOAD_CROSS_SELL_ITEMS',
  LOAD_CROSS_SELL_ITEMS_SUCCESS = 'cross-sell/LOAD_CROSS_SELL_ITEMS_SUCCESS',
  LOAD_CROSS_SELL_ITEMS_FAILURE = 'cross-sell/LOAD_CROSS_SELL_ITEMS_FAILURE',
  REMOVE_CROSS_SELL_ITEM = 'cross-sell/REMOVE_CROSS_SELL_ITEM',
  ADD_CROSS_SELL_SKU = 'cross-sell/ADD_CROSS_SELL_SKU',
  CLEAN_CROSS_SELL_ITEMS = 'cross-sell/CLEAN_CROSS_SELL_ITEMS',
  CHECK_CROSS_SELL_AVAILABLE = 'cross-sell/CHECK_CROSS_SELL_AVAILABLE'
}

export interface CrossSellItemsState extends CrossSellItemsResponseProps {
  loading: boolean;
  error: boolean;
  initialized: boolean;
  hasActivedSkus: boolean;
  addedSkus: string[];
  addedSkusOrigin: Record<string, string>;
  selectedBusinessPartner?: string;
}

export interface CrossSellItemsResponseProps {
  items: SortProductsItem[];
  selected_business_partner?: string;
}
